import { render, staticRenderFns } from "./ClientEmergencyContactSection.vue?vue&type=template&id=17ca647b"
import script from "./ClientEmergencyContactSection.vue?vue&type=script&lang=js"
export * from "./ClientEmergencyContactSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports